import styled from 'styled-components';
import { rem } from 'polished';
import Listbox from '@molecules/Listbox/Listbox';
import Spinner from '@molecules/Spinner/Spinner';
import variables from '@root/styles/variables';
import DesktopScrollbar from '@root/styles/mixins/desktopScrollbar';

export const SearchParamsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
`;

export const StyledSpinner = styled(Spinner)`
  padding: ${rem(20)};
`;

export const StyledListbox = styled(Listbox)`
  ${DesktopScrollbar}
`;

export const StyledInfoBox = styled.div`
  padding: ${rem(16)};
  background: ${variables.colors.highlightBg};
  word-break: break-word;
  border-radius: ${rem(4)};
  margin-bottom: ${rem(20)};
`;

export const StyledEmptySlotContainer = styled.div`
  margin-bottom: ${rem(10)};
`;

export const StyledContainer = styled.div`
  padding: ${rem(6)} ${rem(20)} ${rem(6)} ${rem(20)};
`;

export const StyledEmptySearchContainer = styled.div`
  padding: ${rem(20)};
`;
